import { Alert, Skeleton } from "@mui/material";
import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";
import { useMemo, type FC } from "react";
import type { UUID } from "../../../../../../utils/uuid";
import type { ChannelName } from "../../../../../channels/types";
import { useRecipientsForChannel } from "../../../../../recipients/hooks/use-recipients-for-channel";

const columns: GridColDef[] = [
  { field: "display", headerName: "Name", flex: 1 },
  { field: "destination", headerName: "Destination", flex: 1 },
];

export const AdditionalRecipientsDatagrid: FC<{
  channel: ChannelName;
  recipientIds: UUID[];
  targetChannel: boolean;
}> = ({ channel, recipientIds, targetChannel }) => {
  const { data: allRecipients, loading, error } = useRecipientsForChannel(channel, targetChannel);

  const rows = useMemo(() => {
    if (!allRecipients) return [];
    const idSet = new Set(recipientIds);
    return allRecipients.filter((r) => idSet.has(r.id));
  }, [allRecipients, recipientIds]);

  if (loading) return <Skeleton variant="rectangular" width="100%" height={200} />;
  if (error) return <Alert severity="error">Error loading recipients</Alert>;

  return <DataGridPro rows={rows} columns={columns} pagination showToolbar />;
};
